//General
import React, { useCallback, useEffect } from "react"
import styled from "styled-components"
import useEmblaCarousel from "embla-carousel-react"

//Components
import BackArrow from "@components/SVG/BackArrow"
import { Link } from "react-router-dom"
import useSocketStore from "@state/useSocketStore"
import { useDeviceStore } from "@state/deviceStore"

//Types
interface StartTypes {}

export default function GalleryViews() {
  const syncState = useSocketStore((state) => state.syncState)
  const socket = useSocketStore((s) => s.socket)
  const room = useSocketStore((s) => s.room)
  const emitSocketEvent = useSocketStore((s) => s.emitSocketEvent)
  const setEmbla = useSocketStore((s) => s.setEmbla)
  const isIpad = useDeviceStore((s) => s.isIpad)

  //
  //Initiate carousel
  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: "start",
    containScroll: "trimSnaps",
    loop: true,
    speed: 20,
  })

  const onSelect = useCallback(
    (eventName) => {
      if (emblaApi) {
        const id = emblaApi.selectedScrollSnap()
        syncState("currentAmenityIndex", id)
        setEmbla(id)
      }
    },
    [emblaApi]
  )

  useEffect(() => {
    if (emblaApi) {
      emblaApi.on("select", onSelect)
    }
  }, [emblaApi, onSelect])

  useEffect(() => {
    socket.on("got-embla", ({ data }) => {
      // console.log(data)
      if (emblaApi) {
        // console.log("current id is: ", emblaApi.selectedScrollSnap())
        // console.log("incoming id is: ", data)
        //
        if (data !== emblaApi.selectedScrollSnap()) {
          emblaApi.scrollTo(data)
        }
      }
    })
  }, [emblaApi])

  return (
    <>
      <Link
        to="/gallery"
        onClick={() => {
          emitSocketEvent("navigation", {
            path: "/gallery",
            room: room,
          })
        }}
      >
        <StyledBackArrow />
      </Link>
      {isIpad && <DragToScroll>DRAG TO SCROLL →</DragToScroll>}
      <Embla ref={emblaRef}>
        <EmblaContainer>
          <EmblaSlide>
            <FullImage
              src="/media/gallery/views/gallery--views-1.webp"
              alt=""
            />
          </EmblaSlide>
          <EmblaSlide>
            <FullImage
              src="/media/gallery/views/gallery--views-2.webp"
              alt=""
            />
          </EmblaSlide>
          <EmblaSlide>
            <FullImage
              src="/media/gallery/views/gallery--views-3.webp"
              alt=""
            />
          </EmblaSlide>
          <EmblaSlide>
            <FullImage
              src="/media/gallery/views/gallery--views-4.webp"
              alt=""
            />
          </EmblaSlide>
        </EmblaContainer>
      </Embla>
    </>
  )
}

const DragToScroll = styled.div<StartTypes>`
  position: absolute;
  color: ${(props) => props.theme.colors.white};
  font-size: ${(props) => props.theme.fontSizes.xs};
  font-family: "Gilmer", sans-serif;
  padding: 0.7rem 2rem 0.7rem 2rem;
  bottom: 3%;
  right: 3%;
  background-color: ${(props) => props.theme.colors.green};
  border: 2px solid ${(props) => props.theme.colors.white};
  border-radius: 100px;
  z-index: 3;
  font-weight: 400;
`

const StyledBackArrow = styled(BackArrow)<StartTypes>`
  position: absolute;
  bottom: 3%;
  left: 3%;
  z-index: 3;
  width: 10rem;
  height: 4rem;
`

const Embla = styled.section<StartTypes>`
  height: 100%;
  width: 100%;

  & img {
    pointer-events: none;
  }
`

const EmblaContainer = styled.div<StartTypes>`
  display: grid;
  height: 100%;
  width: 100%;
  grid-auto-flow: column;
  grid-auto-columns: 100%;
`

const EmblaSlide = styled.div<StartTypes>`
  flex: 0 0 100%;
  min-width: 0;
  overflow: hidden;
  background-color: ${(props) => props.theme.colors.black};
`

const FullImage = styled.img<StartTypes>`
  grid-column: 1 / -1;
  grid-row: 1 / -1;
  height: 100%;
  width: auto;
  width: 100%;
  object-fit: cover;
  overflow: hidden;
`
